"use client"

import { useState } from "react"
import { useLanguage } from "../contexts/LanguageContext"

const FilterBar = ({ onFilterChange }) => {
  const { t } = useLanguage()
  const [filters, setFilters] = useState({
    priceRange: "",
    guests: "",
  })

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value }
    setFilters(newFilters)
    if (onFilterChange) {
      onFilterChange(newFilters)
    }
  }
  
  const resetFilters = () => {
    const emptyFilters = {
      priceRange: "",
      guests: ""
    }
    setFilters(emptyFilters)
    if (onFilterChange) {
      onFilterChange(emptyFilters)
    }
  }

  return (
    <section className="filter-bar">
      <div className="container">
        <h2 className="filter-title">{t("filterTitle")}</h2>
        <div className="filters">
          <div className="filter-group">
            <label>{t("priceRange")}</label>
            <select value={filters.priceRange} onChange={(e) => handleFilterChange("priceRange", e.target.value)}>
              <option value="">{t("anyPrice")}</option>
              <option value="0-100">0₪ - 100₪</option>
              <option value="100-200">100₪ - 200₪</option>
              <option value="200-300">200₪ - 300₪</option>
              <option value="300+">300+₪</option>
            </select>
          </div>



          <div className="filter-group">
            <label>{t("guests")}</label>
            <select value={filters.guests} onChange={(e) => handleFilterChange("guests", e.target.value)}>
              <option value="">{t("anyGuests")}</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4+">4+</option>
            </select>
          </div>
          
          <div className="filter-group reset-filter">
            <button className="reset-filters-btn" onClick={resetFilters}>
              {t("resetFilters")}
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FilterBar
